import { readonly } from 'vue';
import { Logger } from '~~/helpers/logger';
import type { LoyaltyPoints } from '~~/types/loyaltyPoints/loyaltyPoints';

export const useLoyaltyPoints = () => {

  const loyaltyPoints = useState<LoyaltyPoints | null>('loyaltyPoints', () => null);
  const loading = useState<boolean>('loyaltyPointsLoading', () => false);
  const error = useState<boolean>('loyaltyPointsError', () => false);
  const requestId = useState<number>('loyaltyPointsRequestId', () => 0);
  const { shouldUseMockData, mockedPartnersData } = useExpondoPartnersMock();

  const isStaleRequest = (id: number) => id !== requestId.value;

  const applyMockedLoyaltyPoints = () => {

    const mockedLoyaltyPoints = mockedPartnersData.value?.loyaltyPoints ?? null;
    loyaltyPoints.value = mockedLoyaltyPoints;
    error.value = mockedLoyaltyPoints === null;

  };

  const load = async () => {

    if (shouldUseMockData.value) {

      applyMockedLoyaltyPoints();

      return;

    }

    if (loading.value || loyaltyPoints.value) {

      return;

    }

    const id = ++requestId.value;
    loading.value = true;
    error.value = false;

    try {

      const response = await $fetch<LoyaltyPoints>('/customer-data-platform/loyalty-points');

      if (!isStaleRequest(id)) {

        loyaltyPoints.value = response;

      }

    } catch (e) {

      if (!isStaleRequest(id)) {

        error.value = true;

      }

      Logger.error(`loyalty-points|fetch: Failed to fetch loyalty points - ${e}`);

    } finally {

      if (!isStaleRequest(id)) {

        loading.value = false;

      }

    }

  };

  const reset = () => {

    requestId.value++;
    loyaltyPoints.value = null;
    loading.value = false;
    error.value = false;

  };

  return {
    loyaltyPoints: readonly(loyaltyPoints),
    loading: readonly(loading),
    error: readonly(error),
    load,
    reset,
  };

};
